export const findTitleById = (arr, id) => {
  if(arr){

    for (const item of arr) {
      if (item.value === id) {
        return item.title;
      }
      if (item.children) {
        const result = findTitleById(item.children, id);
        if (result !== "") {
          return result;
        }
      }
    }
    return "";
  }
};
